import type { Supplier } from '../gql';

import { randCompanyName, randUuid } from '@ngneat/falso';

export const mockSupplier = (override?: Partial<Supplier>): Supplier => ({
    supplierName: randCompanyName(),
    supplierNumber: randUuid(),
    ...override,
    ['__typename']: 'Supplier',
});
